export default __webpack_public_path__ + "static/CHALK BOARD-e7c1621863ed0e6d89433b9f19b407a4.webp";